/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define([], function() {
    'use strict';
    var unitTypes = {
        metric: 'metric',
        imperial: 'imperial'
    };
    return unitTypes;
});



// WEBPACK FOOTER //
// ./config/unit/unitTypes.js